import { BraxSelectOption } from 'design-system';

import { T } from '../utils/i18n';

export type Sector = 'architecture_interior_design' | 'photography' | 'real_estate' | 'furniture' | 'tourism' | 'others';

const sectors: BraxSelectOption<Sector>[] = [{
    value: 'architecture_interior_design',
    title: <T label="Arquitetura | Design de interiores" />
}, {
    value: 'photography',
    title: <T label="Fotografia" />
}, {
    value: 'real_estate',
    title: <T label="Mercado imobiliário | Construção civil" />
}, {
    value: 'furniture',
    title: <T label="Móveis planejados" />
}, {
    value: 'tourism',
    title: <T label="Turismo" />
}, {
    value: 'others',
    title: <T label="Outro" />
}];

export default sectors;
